<template>
  <v-main v-resize="onResize" ref="content" class="pt-0">
    <v-container fluid>
      <!--v-row>
        <page-title />
      </v-row-->
      <v-row style="height: calc(100% - 34px)">
        <v-col cols="12">
          <v-row class="h-75">
            <v-col cols="3">
              <v-row class="h-35">
                <v-col>
                  <v-card class="card-wrap">
                    <v-card-title>{{ $t('dv.title.queue') }}</v-card-title>
                    <div class="box"><queue :value="values.queue" /></div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="h-65">
                <v-col>
                  <v-card class="card-wrap">
                    <v-card-title>{{ $t('dv.title.workprcs') }}</v-card-title>
                    <v-row class="h-50">
                      <v-col cols="4"><work-process :store-name="storeName" type="ENQ" :value="values.ENQ"/></v-col>
                      <v-col cols="4"><work-process :store-name="storeName" type="DIA" :value="values.DIA"/></v-col>
                      <v-col cols="4"><work-process :store-name="storeName" type="BGD" :value="values.BGD"/></v-col>
                    </v-row>
                    <v-row class="h-50">
                      <v-col cols="4"><work-process :store-name="storeName" type="UPD" :value="values.UPD"/></v-col>
                      <v-col cols="4"><work-process :store-name="storeName" type="UP2" :value="values.UP2"/></v-col>
                      <v-col cols="4"><work-process :store-name="storeName" type="SPO" :value="values.SPO"/></v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-card class="d-flex pa-1 bg mb-1" height="39" outlined>
                <div class="mr-auto d-flex">
                  <!--time-navigator v-model="datetime" :increment="1" :active-increment.sync="activeIncrement" :backward="[30, 300]" :forward="[30, 300]"></time-navigator-->
                  <time-navigator-neo v-model="datetime" :increment="1" :active-increment.sync="activeIncrement" :backward="timeStep" :forward="timeStep"></time-navigator-neo>
                  <descendant-selector :store-name="storeName" />
                </div>
                <!--BEGIN::Added.by.KWShin.2024.03.29.-->
                <div>
                  <time-navigator-settings :options="settingOptions" />
                </div>
                <!--FINISH::Added.by.KWShin.2024.03.29.-->
              </v-card>
              <v-row style="height: calc(100% - 41px)">
                <v-col cols="6"><queue-chart ref="queueChart" :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
                <v-col cols="6"><work-process-chart ref="workprcsChart" :sstm-id="systemId" :store-name="storeName" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
                <v-col cols="12"><sap-memory-chart ref="sapMemoryChart" :sstm-id="systemId" :store-name="storeName" :timestamp="timestamp.ABAP_WORK_PROC" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
                <v-col cols="12"><sap-buffer-chart ref="sapBufferChart" :sstm-id="systemId" :store-name="storeName" :timestamp="timestamp.ABAP_QUEUE" :datetime="datetime" :active-increment="activeIncrement"/></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="h-25">
            <v-col cols="12">
              <v-tabs v-model="selected" height="35" slider-size="3" class="rounded-0">
                <template v-for="(grid, idx) in gridList">
                  <v-tab :key="idx" :href="grid.href">{{ grid.text }}</v-tab>
                  <v-tab-item :ref="grid.code" :key="idx" :value="grid.code" :eager="true" transition="false" reverse-transition="false">
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <field-selectable-grid
                        :sstmId="systemId"
                        :code="grid.code"
                        :event-code="grid.eventCode"
                        :selected="selectedFields[grid.code]"
                        :height="height"
                        :on-fetch="grid.onFetch"
                        :store-name="storeName"
                        :timestamp="timestamp[grid.eventCode]"
                      />
                  </v-tab-item>
                </template>
                <v-row class="tab-button">
                  <v-col>
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <field-selector
                        :code="selected"
                        :selected="selectedFields[selected]"
                        :store-name="storeName"
                      />
                    <!-- eslint-disable-next-line prettier/prettier -->
                      <grid-opener
                        :sstmId="systemId"
                        :code="selected"
                        :text="selectedGrid.text"
                        :event-code="selectedGrid.eventCode"
                        :descendants="descendants"
                        :timestamp="timestamp[selectedGrid.eventCode]"
                      />
                  </v-col>
                </v-row>
              </v-tabs>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import bus from '@/utils/bus';
import value from '@/store/dynamic/value';
import settingsGrid from '@/components/motlet/settings/grid';
import FieldSelector from '@/components/motlet/settings/FieldSelector';
import DescendantSelector from '../../components/DescendantSelector';
import FieldSelectableGrid from '../../components/abap/FieldSelectableGridNeo';
import tabItemDenseable from '../../components/tabItemDenseable';
import GridOpener from '../../components/GridOpener';
import referable from '../../components/referable';
import Queue from './value/Queue';
import WorkProcess from './value/WorkProcess';
import QueueChart from './chart/Queue';
import WorkProcessChart from './chart/WorkProcess';
import SapMemoryChart from './chart/SapMemory';
import SapBufferChart from './chart/SapBuffer';
// BEGIN::Added.by.KWShin.2024.03.29.
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
import settingsChart from '@/components/motlet/settings/chart.js';
import TimeNavigatorSettings from '@/components/TimeNavigatorSettings.vue';
// FINISH::Added.by.KWShin.2024.03.29.

export default {
  components: {
    DescendantSelector,
    QueueChart,
    WorkProcessChart,
    SapMemoryChart,
    SapBufferChart,
    Queue,
    WorkProcess,
    FieldSelectableGrid,
    FieldSelector,
    GridOpener,
    // BEGIN::Added.by.KWShin.2024.03.29.
    TimeNavigatorSettings,
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  mixins: [tabItemDenseable, referable],
  data() {
    return {
      grids: [
        { code: 'G_ABAP_WORK_PROC_TYPE', eventCode: 'ABAP_WORK_PROC', text: 'dv.title.workprcs.type' },
        { code: 'G_ABAP_WORK_PROC', eventCode: 'ABAP_WORK_PROC', onFetch: this.onFetchWorkProcess, text: 'dv.title.workprcs' },
        { code: 'G_ABAP_QUEUE', eventCode: 'ABAP_QUEUE', onFetch: this.onFetchQueue, text: 'dv.title.queue' },
        { code: 'G_ABAP_MEMORY', eventCode: 'ABAP_QUEUE', text: 'dv.title.prcs.mem' },
        { code: 'G_ABAP_BUFF', eventCode: 'ABAP_QUEUE', text: 'dv.title.buffer' },
      ],
      timestamp: {
        ABAP_WORK_PROC: 0,
        ABAP_QUEUE: 0,
      },
      // BEGIN::Added.by.KWShin.2022.08.25
      wpTyp: ['ENQ', 'DIA', 'BGD', 'UPD', 'UP2', 'SPO'],
      wpSta: ['Running', 'Waiting', 'OnHold'],
      // FINISH::Added.by.KWShin.2022.08.25
      /*eslint-disable */
      values: {
        queue: [],
        ENQ: { Running: 0, Waiting: 0, OnHold: 0 },
        DIA: { Running: 0, Waiting: 0, OnHold: 0 },
        BGD: { Running: 0, Waiting: 0, OnHold: 0 },
        UPD: { Running: 0, Waiting: 0, OnHold: 0 },
        UP2: { Running: 0, Waiting: 0, OnHold: 0 },
        SPO: { Running: 0, Waiting: 0, OnHold: 0 },
      },
      /*eslint-enable */
      // storeName: 'detailview/abap/process',
      storeName: 'dv/abap/prcs',
      datetime: new Date(),
      activeIncrement: true,
      height: 0,
      selectedGridCode: null,
      // BEGIN::Added.by.KWShin.2024.03.29.
      settingOptions: {
        id: 'dv/abap/prcs',
        // TimeNavigator Interval for Moving
        tnim: {
          use: true,
          np: 10,
          moreNp: 30,
          unit: 10,
          minNp: 10,
          maxNp: 360,
        },
        cycle: 0,
      },
      xPoints: {
        queue: 60,
        workprcs: 60,
        sapMemory: 120,
        // BEGIN::Added.by.SHJ.2026.04.22.
        sapBuffer: 120,
        // FINISH::Added.by.SHJ.2026.04.22.
      },
      chartField: {
        queue: settingsChart['C_ABAP_QUEUE'].fields[0].code,
        workprcs: settingsChart['C_ABAP_WORK_PROC'].fields[0].code,
      },
      sapMemorySettings: {
        memoryType: 'ALL',
        chartType: 'bar',
      },
      // BEGIN::Added.by.SHJ.2026.04.22.
      sapBufferSettings: {
        bufferType: 'ALL',
        chartType: 'bar',
      },
      // FINISH::Added.by.SHJ.2026.04.22.
      // FINISH::Added.by.KWShin.2024.03.29.
    };
  },
  watch: {
    systemId: {
      immediate: true,
      handler() {
        // referable.js 내에 위치한다.
        // router query로 시각이 지정되었는 지를 체크한다.
        this.referer();
        this.setDescendants();
        if (this.activeIncrement) {
          this.$websocket.realtime.connect();
        }
      },
    },
    activeIncrement: {
      handler(value) {
        if (value) {
          this.datetime = new Date();
          this.$websocket.realtime.connect();
        } else {
          this.$websocket.realtime.close();
        }
      },
    },
  },
  computed: {
    ...mapGetters('common/system', ['getDescendantsById']),
    // Added.by.KWShin.2024.03.28.
    ...mapState('common/user', ['username']),
    /**
     * Gnb의 GroupSelector에서 시스템을 변경하면,
     * route의 params의 systemId가 바뀐다.
     */
    systemId() {
      return this.$route.params.systemId;
    },
    selected: {
      get() {
        return this.selectedGridCode ? this.selectedGridCode : this.grids[0].code;
      },
      set(code) {
        this.selectedGridCode = code;
      },
    },
    selectedFields() {
      return this.grids.reduce((acc, gc) => {
        acc[gc.code] = settingsGrid[gc.code].fields.filter(f => f.display).map(f => f.value);
        return acc;
      }, {});
    },
    gridList() {
      // text는 i18n 키 → $t() 호출로 번역. computed라 locale 변경 시 자동 재평가.
      return this.grids.map(gc => ({ href: `#${gc.code}`, ...gc, text: this.$t(gc.text) }));
    },
    descendants() {
      return this.$store.getters[`${this.storeName}/get`];
    },
    selectedGrid() {
      return this.grids.find(grid => grid.code == this.selected);
    },
    // BEGIN::Added.by.KWShin.2024.03.29.
    prcsMonCycle() {
      return this.$store.getters['common/monitor/getMonitor'](this.systemId, 'C_ABAP_WORK_PROC').cycle / 1000;
    },
    timeStep() {
      return [parseInt(this.settingOptions.tnim.np * this.prcsMonCycle), this.settingOptions.tnim.moreNp * this.prcsMonCycle];
    },
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  methods: {
    getActive(descendant) {
      const {
        query: { d: descendantId },
      } = this.$route;
      return descendantId ? descendantId == descendant.id : true;
    },
    setDescendants() {
      if (!this.$store.hasModule(this.storeName.split('/'))) {
        this.$store.registerModules(this.storeName.split('/'), value);
      }
      this.$store.dispatch(
        `${this.storeName}/set`,
        this.getDescendantsById(this.systemId).map(d => ({
          systemId: d.systemId,
          id: d.id,
          color: d.color,
          active: this.getActive(d),
          // Added.by.KWShin.2023.04.18.
          shortAlias: d.shortAlias,
        })),
      );
    },
    onResize() {
      // BEGIN::Modified.by.KWShin.2024.07.05.
      // page-title 부분을 제거해서 높이 조정.
      // const height = window.innerHeight - 160;
      // this.height = height - height * 0.75 - 32;
      const height = window.innerHeight - 123;
      this.height = height - height * 0.75 - 6;
      // FINISH::Modified.by.KWShin.2024.07.05.
    },
    onFetchWorkProcess({ data }) {
      // Added.by.KWShin.2022.08.25
      this.initValues();
      data.forEach(item => {
        if (item.wpIstatus.value == '2') this.values[item.wpTyp]['Waiting']++;
        if (item.wpIstatus.value == '4') this.values[item.wpTyp]['Running']++;
        if (item.wpIstatus.value == '8') this.values[item.wpTyp]['OnHold']++;
      });
    },
    onFetchQueue({ data }) {
      this.values.queue = data;
    },
    addEventListener() {
      // /detailview/components/LineChart.vue에서 차트의 series 데이터가 바뀌면
      // drawMarkLine()를 호출하여 mark line을 새로 그리는 데,
      // 'change:timestamp' 이벤트는 drawMarkLine()에서 발생해준다.
      // 또한, 각 차트 컴포넌트의 wsBufferedDataHandler()에서도 발생해준다.
      bus.$on(`change:timestamp-${this.storeName}`, ({ eventCode, timestamp }) => (this.timestamp[eventCode] = timestamp));
      bus.$on(`change:selected-fields-${this.storeName}`, ({ code, fields }) => (this.selectedFields[code] = fields));
      bus.$on(`set:active-increment-${this.storeName}`, active => (this.activeIncrement = active));
      //BEGIN::Added.by.KWShin.2024.03.28.
      /*
        Commmented.by.KWShin.2024.03.05.
        DetailViewSettings.vue에서 TimeNavigator의 이전/이후 Interval 설정에 변동이 생기면
        서버에 CONF_USER_MTL에 변동 내역을 저장하고
        Bus에서 신호가 온다.
      */
      bus.$on(`update:${this.settingOptions.id}-np`, np => {
        this.settingOptions.tnim.np = np;
      });
      bus.$on(`update:${this.settingOptions.id}-moreNp`, moreNp => {
        this.settingOptions.tnim.moreNp = moreNp;
      });
      bus.$on('update:activeIncrement', active => {
        this.activeIncrement = active;
      });
      //FINISH::Added.by.KWShin.2024.03.28.
    },
    removeEventListener() {
      bus.$off(`change:selected-fields-${this.storeName}`);
      bus.$off(`change:timestamp-${this.storeName}`);
      bus.$off(`set:active-increment-${this.storeName}`);
      //BEGIN::Added.by.KWShin.2024.03.29.
      bus.$off(`update:${this.settingOptions.id}-np`);
      bus.$off(`update:${this.settingOptions.id}-moreNp`);
      bus.$off('update:activeIncrement');
      //FINISH::Added.by.KWShin.2024.03.29.
    },
    // BEGIN::Added.by.KWShin.2022.08.25
    initValues() {
      for (let i = 0; i < this.wpTyp.length; i++) for (let j = 0; j < this.wpSta.length; j++) this.values[this.wpTyp[i]][this.wpSta[j]] = 0;
    },
    // FINISH::Added.by.KWShin.2022.08.25
    /**
     * Added.by.KWShin.2024.03.29.
     * DB에서 각종 설정값을 읽어온다.
     */
    async getMotletProperties() {
      const rspn = await api.get(`/prefer/users/${this.username}/motlet-properties-like`, { params: { motletId: `${this.settingOptions.id}` } });

      let motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/np');
      if (!isEmpty(motletProp)) this.settingOptions.tnim.np = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/moreNp');
      if (!isEmpty(motletProp)) this.settingOptions.tnim.moreNp = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/queue/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.queue = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/workprcs/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.workprcs = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/queue/chartField');
      if (!isEmpty(motletProp)) this.chartField.queue = motletProp.motletProperties;

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/workprcs/chartField');
      if (!isEmpty(motletProp)) this.chartField.workprcs = motletProp.motletProperties;

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapMemory/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.sapMemory = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapMemory/memoryType');
      if (!isEmpty(motletProp)) this.sapMemorySettings.memoryType = motletProp.motletProperties;

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapMemory/chartType');
      if (!isEmpty(motletProp)) this.sapMemorySettings.chartType = motletProp.motletProperties;

      // BEGIN::Added.by.SHJ.2026.04.22.
      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapBuffer/xAxisPoints');
      if (!isEmpty(motletProp)) this.xPoints.sapBuffer = parseInt(motletProp.motletProperties);

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapBuffer/bufferType');
      if (!isEmpty(motletProp)) this.sapBufferSettings.bufferType = motletProp.motletProperties;

      motletProp = rspn.data.find(elm => elm.motletId === this.settingOptions.id + '/sapBuffer/chartType');
      if (!isEmpty(motletProp)) this.sapBufferSettings.chartType = motletProp.motletProperties;
      // FINISH::Added.by.SHJ.2026.04.22.

      this.notify2Children();
    },
    /**
     * Added.by.KWShin.2024.03.29.
     * DB에서 설정값을 읽어오는 것이 완료됐거나
     * systemId, activeIncrement에 변동이 왔을 때
     * 그 사실을 자식에게 알려준다.
     */
    notify2Children() {
      this.$refs.queueChart.xPointsChanged(this.xPoints.queue);
      this.$refs.workprcsChart.xPointsChanged(this.xPoints.workprcs);

      this.$refs.queueChart.chartFieldChanged(this.chartField.queue);
      this.$refs.workprcsChart.chartFieldChanged(this.chartField.workprcs);

      this.$refs.sapMemoryChart.xPointsChanged(this.xPoints.sapMemory);
      this.$refs.sapMemoryChart.memoryTypeChanged(this.sapMemorySettings.memoryType);
      this.$refs.sapMemoryChart.chartTypeChanged(this.sapMemorySettings.chartType);

      // BEGIN::Added.by.SHJ.2026.04.22.
      this.$refs.sapBufferChart.xPointsChanged(this.xPoints.sapBuffer);
      this.$refs.sapBufferChart.bufferTypeChanged(this.sapBufferSettings.bufferType);
      this.$refs.sapBufferChart.chartTypeChanged(this.sapBufferSettings.chartType);
      // FINISH::Added.by.SHJ.2026.04.22.
    },
  },
  async created() {
    await this.getMotletProperties();
    this.addEventListener();
    this.settingOptions.cycle = this.prcsMonCycle;
    /*
     * Added.by.KWShin.2024.08.15.
     * LineChart에서 클릭이 발생. TimeNavigator 기준시각을 변경시켜준다.
     */
    bus.$on(`click:chart-${this.storeName}`, xAxisValue => {
      this.datetime = new Date(xAxisValue);
    });
  },
  destroy() {
    this.removeEventListener();
    this.$websocket.realtime.close();

    // Added.by.KWShin.2024.08.15.
    bus.$off(`click:chart-${this.storeName}`);
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: initial !important;
}

.tab-button {
  text-align: end;
}

.tab-button .col {
  margin: 3px 0 0 0;
}
</style>
